var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rt-card",style:({ minWidth: _vm.width })},[_c('header',[_vm._t("header",function(){return [_c('p',{staticClass:"rt-card-header"},[_vm._v(_vm._s(_vm.title))])]}),_vm._t("extra")],2),_c('main',{staticClass:"rt-card-main",style:({ height: _vm.height})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }